module.exports = __webpack_public_path__ + "img/i-analytical-data-admin.17ba6de4.svg";